/* eslint-disable */
import { SCREEN_TITLES } from '../../constants/strings';

// profile navigation
const pathToTitle = path => {
  const parts = path.split('/');
  const endsWith = parts[parts.length - 1];
  const slug = isNaN(endsWith) ? endsWith : parts[parts.length - 2];

  return SCREEN_TITLES[slug];
};

export default pathToTitle;



// WEBPACK FOOTER //
// ./src/utils/converters/pathToTitle.js